module.exports = "<button class=\"{{$root.styles.buttons.floating}} {{myStyle}}\"\n  ng-class=\"{'btn-large': enableLarge, 'btn-space': enableLarge}\"\n  ng-disabled=\"myDisabled\"\n  ng-click=\"myClick()\">\n  <label ng-bind-html=\"myLabel\"></label>\n  <i class=\"{{$root.styles.icons.classic}}\"\n    ng-class=\"{'large': enableLarge}\"\n    ng-bind-html=\"myIcon\">\n  </i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/buttons/myFloatingButton.html
// module id = 1202
// module chunks = 0